"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedFilter = void 0;
const react_1 = __importStar(require("react"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const AdvancedFilterItem_1 = require("./components/AdvancedFilterItem/AdvancedFilterItem");
const AdvancedFilterDataSelectorIds_1 = require("./helpers/AdvancedFilterDataSelectorIds");
const ColumnGroupsLayout_1 = require("../ColumnGroupsLayout");
const CommandActions_1 = require("../CommandActions");
const controls_1 = require("../controls");
const Dropdown_1 = require("../controls/Dropdown");
const Dialog_1 = require("../Dialog");
const FilterMenu_1 = require("../FilterMenu");
const FilterMenuBody_1 = require("../FilterMenuBody");
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const AdvancedFilterDefaultTexts_1 = require("./helpers/AdvancedFilterDefaultTexts");
const icons_1 = require("./icons");
const utils_1 = require("./utils");
exports.AdvancedFilter = (0, helpers_1.createUIElement)('AdvancedFilter', (_a, ref) => {
    var { className, value = [], label, options, onChange, texts, disabled, comparator = fast_deep_equal_1.default, size, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "value", "label", "options", "onChange", "texts", "disabled", "comparator", "size", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const uiTexts = (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({}, AdvancedFilterDefaultTexts_1.ADVANCED_FILTER_DEFAULT_TEXTS), texts);
    }, [texts]);
    const { getValue, setValue } = (0, helpers_1.useStateValue)(value, [value]);
    const maxLength = (0, react_1.useMemo)(() => {
        return options.cols.reduce((res, column) => {
            let colItems = 0;
            column.groups.forEach((group) => {
                colItems += group.items.length;
            });
            return res + colItems;
        }, 0);
    }, [options]);
    const renderOptionsData = (0, react_1.useCallback)((rowKey, groupKey, optionsData) => {
        return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s }, optionsData.map(({ iconSrc, label, value, testId }, optionKey) => {
            const checked = getValue().some((i) => {
                return comparator(i, value);
            });
            const handleChange = (0, react_1.useCallback)((isChecked) => {
                let nextValue = getValue().filter((i) => !comparator(i, value));
                if (isChecked) {
                    nextValue = [...nextValue, value];
                }
                setValue(nextValue);
            }, [value]);
            return (react_1.default.createElement(AdvancedFilterItem_1.AdvancedFilterItem, { key: `advanced-filter-menu-option-${rowKey}-${groupKey}-${optionKey}`, onChange: handleChange, testId: testId, iconSrc: iconSrc, label: label, checked: checked }));
        })));
    }, [comparator, getValue, setValue]);
    const columns = (0, react_1.useMemo)(() => {
        return options.cols.map(({ groups }, rowKey) => {
            return {
                groups: groups.map(({ title, items: optionsData }, groupKey) => {
                    return {
                        title,
                        render: () => renderOptionsData(rowKey, groupKey, optionsData)
                    };
                })
            };
        });
    }, [options.cols, renderOptionsData]);
    return (react_1.default.createElement(Dropdown_1.Dropdown, { ref: ref, renderControl: ({ button, isActive }) => (react_1.default.createElement(controls_1.SelectButton, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.mainButton, ref: button.ref, style: style, className: (0, helpers_1.cn)('vm-AdvancedFilter', className), onClick: onClick, onMouseDown: (e) => {
                button.onMouseDown(e);
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
            }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: (e) => {
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
            }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, active: isActive, disabled: disabled, iconBefore: react_1.default.createElement(icons_1.FilterIcon, null), size: size, iconAfter: null }), (0, utils_1.getCaption)({ value: getValue(), maxLength, label, texts: uiTexts }))), renderContent: ({ actions }) => (react_1.default.createElement(FilterMenuBody_1.FilterMenuBody, { title: options.header, headerAddon: react_1.default.createElement(CommandActions_1.CommandActions, { items: [
                    {
                        testId: AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.allButton,
                        text: uiTexts.all,
                        onClick: () => setValue((0, utils_1.selectAll)(options))
                    },
                    {
                        testId: AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.noneButton,
                        text: uiTexts.none,
                        onClick: () => setValue([])
                    }
                ] }), actions: [
                {
                    text: uiTexts.apply,
                    testId: AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.apply,
                    onClick: () => {
                        onChange === null || onChange === void 0 ? void 0 : onChange(getValue());
                        actions.hide();
                    }
                },
                {
                    text: uiTexts.cancel,
                    view: Dialog_1.ACTION_VIEW.secondary,
                    testId: AdvancedFilterDataSelectorIds_1.AdvancedFilterDataSelectorIds.cancel,
                    onClick: () => {
                        setValue(value);
                        actions.hide();
                    }
                }
            ], content: react_1.default.createElement(ColumnGroupsLayout_1.ColumnGroupsLayout, { columns: columns }) })), renderPopover: ({ popover, content }) => (react_1.default.createElement(FilterMenu_1.FilterMenu, Object.assign({}, popover, { "data-selector-id": "popover-menu" }), content)), onOutsideClick: () => {
            setValue(value);
        } }));
});
//# sourceMappingURL=AdvancedFilter.js.map